/**
 * 원본 폴더 한 칸의 항목.
 *
 * 서버가 스토어를 그때그때 읽어 주므로 화면도 폴더 단위로만 안다 — 전체 트리를 들고 있지
 * 않는다. 포맷을 가리지 않아 Misc 는 이 목록이 전부이고 LeRobot 은 여기에 점검이 더 붙는다.
 *
 * Owns:
 * - 화면이 다루는 파일 · 폴더 값과 경로 조합.
 *
 * Does not own:
 * - wire 응답 해석 — `api/datasetFileApi.ts`. 크기 표기 — `feature/datasetFormatters.ts`.
 */

export type SourceFile = {
  /** 부모 기준 이름. 예) `"info.json"`. */
  name: string;
  /** 데이터셋 root 기준 상대 경로. 예) `"meta/info.json"`. */
  path: string;
  isDir: boolean;
  /** 파일 크기. 폴더는 `null` 이다 — 0 과 "없음" 을 접지 않는다. */
  sizeBytes: number | null;
};

export type SourceFilePage = {
  /** 읽은 폴더의 root 기준 경로. root 면 빈 문자열. */
  parent: string;
  entries: readonly SourceFile[];
  /** 다음 페이지 토큰. 마지막이면 `null`. */
  cursor: string | null;
};

/** 지금 폴더에서 위로 한 칸. root 면 `null` — 데이터셋 밖으로 나가지 않는다. */
export function parentOf(path: string): string | null {
  if (path === "") {
    return null;
  }
  const cut = path.lastIndexOf("/");
  return cut === -1 ? "" : path.slice(0, cut);
}

/** 빵부스러기 — root 부터 지금 폴더까지의 (이름, 경로) 목록. */
export function breadcrumbOf(path: string): readonly { name: string; path: string }[] {
  if (path === "") {
    return [];
  }
  const segments = path.split("/");
  return segments.map((name, index) => ({
    name,
    path: segments.slice(0, index + 1).join("/"),
  }));
}
